module.exports = __webpack_public_path__ + "sciezka4.png?59ea0cc308df9857386b6c14273eeb2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sciezka4.png
// module id = 30
// module chunks = 0